export const initialState = {
  filters: {},
  users: [],
  reviewers: []
};
